import React, {useState} from "react";
import "../../../css/navigation.scss"

const UserPopup = React.forwardRef(({shown}, ref) =>
{
    const logout = () =>
    {
        fetch("/api/logout", { credentials: "include", method: "POST" })
            .then(res =>
            {
                if(!res.ok)
                {
                    console.error("Logout failed with status:", res.status);
                }
            })
            .catch(err =>
            {
                console.error("Logout error:", err);
            })
            .finally(() => window.location.href = "/");
    };

    const handleFileChange = (event) =>
    {
        const formData = new FormData();
        formData.append('profilePicture', event.target.files[0]);

        fetch("/api/profile-picture", { credentials: "include", method: "POST", body: formData })
            .then(res =>
            {
                console.log(res.statusMessage);
                if(res.ok) window.location.reload();
            })
    };

    return (
        <div ref={ref} className={"popup-area" + (shown ? " shown" : "")}>
            <input id="profile-picture-input" className="hidden" type="file" onChange={handleFileChange} accept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/wbmp"/>
            <label className="popup-button" htmlFor="profile-picture-input">
                Change Profile Picture
            </label>
            <button className="popup-button" onClick={logout}>
                Logout
            </button>
        </div>
    );
});

export default UserPopup;